<template>
  <span v-if="type == 1">
    <vue-countdown
      :class="`text-${color}`"
      @end="onCountdownEnd"
      v-if="counting"
      :time="getDiff(time)"
      v-slot="{ days, hours, minutes, seconds }"
    >
      {{ days }} روز, {{ hours }} ساعت, {{ minutes }} دقیقه,
      {{ seconds }} ثانیه.
    </vue-countdown>
    <b-badge variant="light-danger" v-else>وقت تمام شد</b-badge>
  </span>
  <span v-else>
    <vue-countdown
      class="d-flex flex-row-reverse flex-wrap"
      @end="onCountdownEnd"
      v-if="counting"
      :time="getDiff(time)"
      v-slot="data"
    >
      <template v-for="(item, key, index) in data">
        <b-button
          v-if="
            key == 'days' ||
            key == 'hours' ||
            key == 'minutes' ||
            key == 'seconds'
          "
          :key="index"
          size="sm"
          :variant="color"
          class="d-flex flex-column justify-content-center align-items-center ml-25 my-50"
        >
          <span>{{ item }}</span
          ><span>{{
            key === "days"
              ? "روز"
              : key === "hours"
              ? "ساعت"
              : key === "minutes"
              ? "دقیقه"
              : "ثانیه"
          }}</span>
        </b-button>
      </template>
    </vue-countdown>
    <b-badge variant="light-danger" v-else>وقت تمام شد</b-badge>
  </span>
</template>

<script>
import { BBadge, BSkeleton, BButton } from "bootstrap-vue";
import VueCountdown from "@chenfengyuan/vue-countdown";
let moment = require("jalali-moment");

export default {
  components: {
    BBadge,
    BSkeleton,
    BButton,
    VueCountdown,
  },
  props: {
    time: {
      type: String,
    },
    type: {
      type: Number,
      default: 2,
    },
    color: {
      type: String,
      default: "danger",
    },
  },
  data() {
    return {
      counting: true,
    };
  },

  methods: {
    onCountdownEnd: function () {
      this.counting = false;
      this.$emit("input", false);
    },
    getDiff(time) {
      let currentDate = moment();
      let myDate = moment.utc(time).local();
      let diffTime = myDate.diff(currentDate, "seconds");
      let finalDate = Number(diffTime) * 1000;
      return Number(finalDate) > 0 ? finalDate : 0;
    },
  },
};
</script>

<style></style>
